@if (visible()) {
  <div
    class="page-loader"
    @fadeInOut
    role="alert"
    aria-live="assertive"
    [attr.aria-busy]="visible()">
    <mat-progress-bar
      mode="indeterminate"
      color="primary"
      [attr.aria-label]="'COMMON.LOADING_PROGRESS' | translate" />
  </div>
}
